import { waLink } from "../config/site";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const WhatsAppFloat = () => (
  <a
    href={waLink("Hello SparkGrid Solutions! I'd like to discuss a project.")}
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="Chat with SparkGrid Solutions on WhatsApp"
    className="group fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-wa shadow-xl shadow-wa/40 transition-transform duration-300 hover:scale-110"
  >
    <span className="absolute inset-0 animate-ping rounded-full bg-wa/40 [animation-duration:2.4s]" />
    <WhatsAppIcon className="relative h-7 w-7 text-white" />
  </a>
);
